import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Theater } from "lucide-react";

// In "Anni e corsi" resta solo la data: i dettagli si gestiscono in Spettacoli
export const OpenInShows = ({ i, unsaved }) => (
  <a href="/admin?tab=shows" onClick={(e) => { if (unsaved && !window.confirm("Ci sono modifiche non salvate in Docenti e saggi: andranno perse. Continuare?")) e.preventDefault(); }}
    className="inline-flex items-center gap-1 text-xs text-primary underline underline-offset-2" data-testid={`course-meta-open-shows-${i}`}>
    <Theater size={12} /> Apri in Spettacoli
  </a>
);

export const MidRecital = ({ r, i, upd, unsaved }) => (
  <div className="flex flex-wrap items-end gap-3" data-testid={`course-meta-mid-${i}`}>
    <div className="w-full sm:w-56"><Label className="text-xs">Saggio di metà anno (facoltativo)</Label>
      <Input data-testid={`course-meta-mid-date-${i}`} type="date" value={r.mid_recital_date || ""} onChange={(e) => upd(r.course, { mid_recital_date: e.target.value })} className="mt-1 bg-white" /></div>
    {(r.recital_date || r.mid_recital_date) && <div className="pb-2"><OpenInShows i={i} unsaved={unsaved} /></div>}
  </div>
);

const KIND_L = { mid: "metà anno", final: "fine anno" };

// Data cancellata ma spettacolo collegato già compilato: il master sceglie
export const LinkedShowDialog = ({ open, conflict, onChoose, onCancel }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent data-testid="linked-show-dialog" className="w-[calc(100%-1.5rem)] sm:max-w-xl rounded-lg">
      <DialogHeader>
        <DialogTitle>Spettacolo del saggio già compilato</DialogTitle>
        <DialogDescription>Hai cancellato la data del saggio di {conflict?.shows.map((s) => KIND_L[s.kind]).join(" e ")} di "{conflict?.course}", ma lo spettacolo collegato contiene già dei dettagli.</DialogDescription>
      </DialogHeader>
      <ul className="text-sm list-disc pl-5">{conflict?.shows.map((s) => <li key={s.event_id} className="break-words">{s.title}</li>)}</ul>
      <DialogFooter className="flex-col sm:flex-row sm:flex-wrap sm:justify-end gap-2">
        <Button variant="outline" onClick={onCancel} data-testid="linked-show-cancel">Annulla</Button>
        <Button variant="outline" onClick={() => onChoose("unlink")} data-testid="linked-show-unlink">Tienilo come spettacolo normale</Button>
        <Button variant="destructive" onClick={() => onChoose("delete")} data-testid="linked-show-delete">Elimina lo spettacolo</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
